import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import "../App.css"

const DropDownMultiSelectMFACustom = (props) => {
  const overrideStrings = {
    "allItemsAreSelected": "All selected",
    "clearSearch": "Clear Search",
    "noOptions": "No options",
    "search": "Search",
    "selectAll": "Select All",
    "selectSomeItems": "--Select--"
  }

  const [selected, setSelected] = useState([]);

  const handleOnChange = (objs) => {
    setSelected(objs)
    props.setParentDropdownValue(objs, props.title)
  }

  return (
    <>
      <label style={{ paddingLeft: "5px", fontSize: "small" }}>{props.title}</label>
      {/* <pre>{JSON.stringify(selected)}</pre> */}
      <MultiSelect
        className="brand-category-multi-select-custom"
        options={props.options}
        value={selected}
        onChange={handleOnChange}
        labelledBy="Select"
        disableSearch={true}
        overrideStrings={overrideStrings}
      />
    </>
  );
};

export default DropDownMultiSelectMFACustom;